import { render, staticRenderFns } from "./BatchPriceAnalysis.vue?vue&type=template&id=b63f93f2&scoped=true&"
import script from "./BatchPriceAnalysis.vue?vue&type=script&lang=js&"
export * from "./BatchPriceAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./BatchPriceAnalysis.vue?vue&type=style&index=0&id=b63f93f2&lang=scss&scoped=true&"
import style1 from "./BatchPriceAnalysis.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63f93f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VList,VListItem,VMenu,VRow})
